import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M533-88H194q-45 0-75.5-30.5T88-194v-339h445v445Zm-402-82h348L366-323l-84 109-60-79-91 123Zm63-596H88q0-45 30.5-75.5T194-872v106Zm64 0v-106h106v106H258Zm169 0v-106h106v106H427Zm170 0v-106h106v106H597Zm0 678v-106h106v106H597Zm169-678v-106q45 0 75.5 30.5T872-766H766ZM88-597v-106h106v106H88Zm678 403h106q0 45-30.5 75.5T766-88v-106Zm0-64v-106h106v106H766Zm0-169v-106h106v106H766Zm0-170v-106h106v106H766Z" }, null, -1)
  ]))]))
}
export default { render: render }